import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as TopicsActions from "../../actions/topicsActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const loadTopicsLogic = createLogic({
	type: ActionTypes.LOAD_TOPICS,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get("/apps/" + action.appKey + "/topics")
					.then(data => {
						dispatch(TopicsActions.loadTopicsSuccess(data.data));
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						done();
					});
			});
	},
});

export default [loadTopicsLogic];
